import { render, staticRenderFns } from "./InfosetsMembersMenu.container.vue?vue&type=template&id=486a46c4&scoped=true&"
import script from "./InfosetsMembersMenu.container.vue?vue&type=script&lang=ts&"
export * from "./InfosetsMembersMenu.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a46c4",
  null
  
)

export default component.exports